import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;

  .ant-typography {
    font-family: InterRegular, sans-serif;
  }

  .listItemTitle {
    white-space: nowrap;
    margin-right: 15px;
  }
`;
